// import {
//   Info as Icon // TODO: select an icon
// } from 'components/icons';
import React from 'react';
import { Icon } from 'semantic-ui-react';

function TheIcon () {
  return <Icon name="upload" />;
}

export const meta = {
  id: 'DrivesDetails',
  title: 'DrivesDetails',
  category: 'Utils',
  unique: false,
  icon: TheIcon,
  version: '1.0.0',
  description: `The drive for the storage services`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 670,
    height: 510
  }
};
